import React, { Component } from 'react';
import cn from 'classnames';
import styles from './styles.scss';

import GoogleMap from 'google-map-react';
import { fitBounds } from 'google-map-react/utils';
import MapPoint from 'components/common/MapPoint/MapPoint';
import { ROOT_URL, MAP_API_KEY } from 'constants/Config';
import { formatPhoneNumber, addUrlProtocol } from 'utils';

import iconSocVk from 'assets/images/icons/social-vk.svg';
import iconSocOk from 'assets/images/icons/social-ok.svg';
import iconSocFb from 'assets/images/icons/social-fb.svg';
import iconSocInst from 'assets/images/icons/social-inst.svg';
import iconSocYoutube from 'assets/images/icons/social-youtube.svg';
import { useTranslation, withTranslation } from 'react-i18next';


const OfficePin = (props) => {
  const { t } = useTranslation();
  const { phone, address, mail, name = t('components.realtorPopup.in') } = props;
  return (

    <div>

      <MapPoint
        className={styles.MapPoint}
        onClick={props.handleShowInfo}
      />

      <div className={styles.MapTooltip}>
        <p className={styles.MapTooltipTitle}>{name}</p>
        <p className={styles.MapTooltipAddress}>{address}</p>
        <a href={`tel:${phone}`} className={styles.MapTooltipPhone}>{formatPhoneNumber(phone)}</a>
        <a href={`mailto:${mail}`} className={styles.MapTooltipEmail}>{mail}</a>
      </div>

    </div>
  );
};

const size = {
  width: 600,
  height: 600
};

class RealtorPopup extends Component {

  state = {
    isMapOpened: false
  }

  handleMapButtonClick = () => {
    this.setState({
      isMapOpened: !this.state.isMapOpened
    });
  }

  UNSAFE_componentWillMount() {
    if (this.props.agency) {
      this.mapProps = this.fitBounds(
        this.props.agency.office
        .filter(
          ({ latitude, longitude }) => latitude && longitude
        )
        .map(
          o => ({
            ...o,
            latitude: parseFloat(o.latitude) - 0.0008,
            longitude: parseFloat(o.longitude)
          })
        )
      );
    }
  }
  componentDidMount() {
    const popupHeight = document.getElementById('CompanyDialogWrap').clientHeight;
    this.setState({ popupHeight });
  }

  fitBounds(data) {
    let maxLat = 0,
      minLat = 1000,
      maxLng = 0,
      minLng = 1000;

    if (data.length > 1) {
      data.forEach((item, i) => {
        const { latitude, longitude } = item;
        if (latitude > maxLat) maxLat = latitude;
        if (latitude < minLat) minLat = latitude;
        if (longitude > maxLng) maxLng = longitude;
        if (longitude < minLng) minLng = longitude;
      });
    } else {
      const { latitude, longitude } = data[0];
      maxLat = latitude + 0.005;
      minLat = latitude - 0.005;
      maxLng = longitude + 0.005;
      minLng = longitude - 0.005;
    }

    const bounds = {
      nw: {
        lat: maxLat,
        lng: minLng
      },
      se: {
        lat: minLat,
        lng: maxLng
      }
    };

    return fitBounds(bounds, size);
  }

  render() {
    const { agency, t } = this.props;
    const {
      name,
      description,
      vk,
      ok,
      facebok,
      instagram,
      youtube,
      office = [],
      logoId,
      website,
      backgroundId
    } = agency;

    let isOfficeCoords = true;
    for (let i = 0; i < office.length; i++) {
      if (!office[i].latitude && !office[i].longitude) {
        isOfficeCoords = false;
      }
    }

    return (
      <div className={cn(styles.CompanyDialogWrap, { [styles.WithoutMap]: !isOfficeCoords }, { [styles.MapOpened]: this.state.isMapOpened })} id="CompanyDialogWrap" style={{ height: this.state.popupHeight }}>

        {isOfficeCoords ? (
          <div className={styles.CompanyDialogMap} style={{ height: this.state.popupHeight }}>
            <div className={styles.MapHeader}>
              {t('components.realtorPopup.onMap')}
            </div>
            <GoogleMap
              options={(maps) => ({
                panControl: this.state.isMapOpened,
                zoomControl: this.state.isMapOpened,
                streetViewControl: this.state.isMapOpened,
                mapTypeControl: false,
                scrollwheel: true,
                panControlOptions: {
                  position: maps.ControlPosition.TOP_RIGHT
                },
                styles: [
                  {
                    featureType: 'all',
                    stylers: [{ visibility: 'on' }]
                  }
                ]
              })}
              bootstrapURLKeys={{
                key: MAP_API_KEY,
                language: 'ru',
                region: 'ru'
              }}
              center={this.mapProps.center}
              defaultZoom={this.mapProps.zoom}
            >
              {
                  office.map(
                      ofc =>
                          (ofc.latitude && ofc.longitude) ?
                            <OfficePin
                              {...ofc}
                              key={ofc.id}
                              lat={parseFloat(ofc.latitude)}
                              lng={parseFloat(ofc.longitude)}
                            /> : null
                  )
                }
            </GoogleMap>
            {/* Офисы на карте */}
            <button className={styles.CompanyDialogMapButton} onClick={this.handleMapButtonClick}>
              {this.state.isMapOpened ? t('components.realtorPopup.minMap') : t('components.realtorPopup.showMap')}
            </button>
          </div>
        ) : null}

        <div
          className={styles.CompanyDialogHeader}
          style={{ backgroundImage: `url(${ROOT_URL}/image/get?id=${backgroundId}&preset=background)` }}
        >
          <div className={styles.CompanyLogo}>
            {
              logoId ?
                <img src={`${ROOT_URL}/image/get?id=${logoId}&preset=profile_avatar`} alt="" /> : null
            }
          </div>
        </div>
        <div className={styles.CompanyDialogBody}>
          <p className={styles.CompanyName}>
            { name }
          </p>
          <p className={cn(styles.CompanyDescription, 'custom-scrollbar')}>
            { description }
          </p>
          <div className={styles.CompanySocial}>
            {
              [
                { url: vk, icon: iconSocVk },
                { url: ok, icon: iconSocOk },
                { url: facebok, icon: iconSocFb },
                { url: instagram, icon: iconSocInst },
                { url: youtube, icon: iconSocYoutube }
              ].filter(
                ({ url }) => url
              ).map(
                ({ url, icon }) =>
                  <a href={addUrlProtocol(url)} className={styles.CompanySocialLink} target="_blank">
                    <img src={icon} alt="" />
                  </a>
              )
            }
          </div>

          {
            office.slice(0, 1).map(
              ({ id, phone, address, mail }) => (
                <div className={styles.CompanyContacts}>
                  {((phone || address) && (mail || website)) ? (
                    <div className={styles.CompanyContactsInner}>
                      {
                          (phone || address) &&
                          <div className={styles.CompanyContactsLeft} key={id}>
                            {
                              phone &&
                              <div className={styles.CompanyContactsItem}>
                                <p className={styles.Label}>
                                  {t('components.realtorPopup.phone')}
                                </p>
                                <a href={`tel:${phone}`} className={styles.Text}>{formatPhoneNumber(phone)}</a>
                              </div>
                            }
                            {
                              address &&
                              <div className={styles.CompanyContactsItem}>
                                <p className={styles.Label}>{t('components.realtorPopup.address')}</p>
                                <p className={styles.Text}>{address}</p>
                              </div>
                            }
                          </div>
                        }
                      { (mail || website) &&
                        <div className={styles.CompanyContactsRight}>
                          {
                            mail &&
                            <div className={styles.CompanyContactsItem}>
                              <p className={styles.Label}>
                                {t('components.realtorPopup.email')}
                              </p>
                              <a href={`mailto:${mail}`} className={cn(styles.Link)}>{mail}</a>
                            </div>
                          }
                          {
                            website &&
                            <div className={styles.CompanyContactsItem}>
                              <p className={styles.Label}>
                                {t('components.realtorPopup.website')}
                              </p>
                              <a href={addUrlProtocol(website, 'http')} target="_blank" className={cn(styles.Link)}>{website}</a>
                            </div>
                          }
                        </div>
                        }
                    </div>
                  ) : (
                      (phone || address) ? (
                        <div className={cn(styles.CompanyContactsLeft, styles.Wide)} key={id}>
                          {
                              phone &&
                              <div className={styles.CompanyContactsItem}>
                                <p className={styles.Label}>
                                  {t('components.realtorPopup.phone')}
                                </p>
                                <a href={`tel:${phone}`} className={styles.Text}>{formatPhoneNumber(phone)}</a>
                              </div>
                            }
                          {
                              address &&
                              <div className={styles.CompanyContactsItem}>
                                <p className={styles.Label}>
                                  {t('components.realtorPopup.address')}
                                </p>
                                <p className={styles.Text}>{address}</p>
                              </div>
                            }
                        </div>
                      ) : (null)
                  )}
                </div>
              )
            )
          }
        </div>

      </div>
    );
  }
}

export default withTranslation()(RealtorPopup);



// WEBPACK FOOTER //
// ./src/components/RealtorPopup/RealtorPopup.js